import { useQuery } from "@tanstack/react-query";
import React, { useEffect, useMemo } from "react";
import {useNavigate} from "react-router-dom"

const FMP_BATCH_QUOTES_URL = "https://financialmodelingprep.com/stable/batch-quote";

function MarketItem({ item }) {
  const navigate = useNavigate()

  return (
    <div className="home-ticker-item">
      <span 
        className="home-ticker-label"
        onClick={() => navigate(`/stock/${item.symbol}`)}
        style={{
          cursor: "pointer"
        }}
      >{item.name}({item.symbol})</span>
      <span className={`home-ticker-value ff-numerals ${item.change < 0 ? 'text-danger' : 'text-success'}`}>
        {item.price}
      </span>
      <span className={`home-ticker-change ff-numerals ${item.change < 0 ? 'text-danger' : 'text-success'}`}>
        {item.change > 0 ? `+${item.change}` : item.change} 
        ({Number(item.changePercentage).toFixed(2) > 0 ? `+${Number(item.changePercentage).toFixed(2)}` : Number(item.changePercentage).toFixed(2)}%)
      </span>
    </div>
  );
}

function fetchGuruHoldStocks(tickers) {
  const url = `${FMP_BATCH_QUOTES_URL}?symbols=${tickers}&apikey=${process.env.REACT_APP_FINANCIAL_API_KEY}`;
  return fetch(url)
    .then((response) => response.json())
    .then((data) => {
      const quotes = data.reduce((acc, item) => {
        acc[item.symbol] = item;
        return acc;
      }, {});
      return tickers.split(",").map((ticker) => quotes[ticker]);
    });
}

export default function MarketOverview({ curations = [] }) {
  const guruHoldStocksTickers = curations
    .filter((item) => (item.seltype === "guruHoldStock"))
    .sort(((a,b) => a.rank - b.rank))
    .slice(0, 10)
    .map((item) => item.ticker)
    .join(",");
  
  const guruHoldStocks = useQuery({
    queryKey: ["guruHoldStocks"],
    queryFn: () => fetchGuruHoldStocks(guruHoldStocksTickers),
    enabled: !!guruHoldStocksTickers,
  });

  const guruHoldStocksData = useMemo(() => guruHoldStocks.data || [], [guruHoldStocks.data]);

  useEffect(() => {
    if (!guruHoldStocksData) return;  
  }, [guruHoldStocksData]);

  return (
    <div className="home-ticker">
      <div className="home-ticker-marquee">
        <div className="home-ticker-track home-ticker-track--rolling">
          {guruHoldStocksData.map((item) => (
            <MarketItem key={item.symbol} item={item} />
          ))}
        </div>
      </div>
    </div>
  );
}
